<template>
    <div class="row">
        <div class="col-md-12">
            <v-card class="my-shadow" >
                            <v-card-title class="v-card-title-text">All orders</v-card-title>
                <v-card-text>
                    <div>
                        <div class="w-100 d-flex flex-row justify-space-between">
                            <div class="w-100 d-flex flex-row flex-wrap">
                                <div class="d-flex my-3 mr-5" v-for="status in filterStatuses">
                                    <div class="d-flex" style="width: 26px; height: 26px; border-radius: 100%" :style="{'background-color': status.hex}"></div>
                                    <div class="ml-1">{{status.name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <v-row>
                        <v-col md="3" sm="6" cols="6" class="d-flex align-center">
                            <v-text-field class="no-validation" append-icon="mdi-magnify" clearable :label="$t('Search')" v-model="filter_params.term" outlined></v-text-field>
                        </v-col>
                        <v-col md="2" sm="6" cols="6">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        outlined
                                        v-model="filter_params.from_date"
                                        label="From date"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable
                                        class="no-validation"
                                        @click:clear="filter_params.from_date = null"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filter_params.from_date"
                                    scrollable
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col md="2" sm="6" cols="6">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        outlined
                                        v-model="filter_params.to_date"
                                        label="To date"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable
                                        class="no-validation"
                                        @click:clear="filter_params.to_date = null"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filter_params.to_date"
                                    scrollable
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col md="3" sm="6" cols="6">
                            <v-select class="no-validation" clearable v-model="filter_params.filter_website_id" :items="websites" item-text="name" item-value="id" outlined :label="$t('View by store')"></v-select>
                        </v-col>
                        <v-col md="2" sm="6" cols="6">
                            <v-select class="no-validation" clearable v-model="filter_params.status" :items="filterStatuses" item-text="name" item-value="key" outlined :label="$t('View by status')"></v-select>
                        </v-col>

                    </v-row>
                    <div v-if="orders" style="overflow: scroll" class="header-center-align">
                        <v-data-table
                            :loading="load"
                            :items="orders"
                            :headers="headers"
                            :header-props="{ sortIcon: null }"
                            :options.sync="params"
                            :expanded.sync="expanded"
                            :server-items-length="orders.total"
                            :footer-props="{'items-per-page-options': [10, 20, 50, 100]}"
                        >
                            <template v-slot:item.website="{item}">
                                {{item.website.name}}
                            </template>
                            <template v-slot:item.status="{item}">
                                <div style="height: 100%;width: 100%;" class="d-flex justify-center align-center">
                                    <div style="width: 26px; height: 26px; border-radius: 100%" :style="{'background-color': getStatus(item.status).hex}"></div>
                                </div>
                            </template>
                            <template v-slot:item.email="{item}">
                            <span @click.prevent.stop>
                                <span v-chunk="10">{{item.email}}</span>
                            </span>
                            </template>
                            <template v-slot:item.buyer="{item}">{{item.website.name}}</template>
                            <template v-slot:item.actions="{item}">
                                <div @click.stop class="d-flex justify-center align-center">
                                    <v-btn style="width: 26px; height: 26px;" :to="'/orders/'+item.hash" target="_blank" x-small fab color="primary" dark class="my-1 mr-2"><v-icon width="13px" height="13px" style="font-size: 13px;">mdi-eye</v-icon></v-btn>
                                    <v-btn @click="cancelOrder(item)" v-if="item.status === 'new' ||item.status === 'in_progress' " fab style="width: 26px; height: 26px;" x-small class="py-1" color="red" dark><v-icon style="font-size: 18px;">mdi-cancel</v-icon></v-btn>
                                    <v-btn :to="'/master/admin/order/'+item.hash" v-if="item.status === 'canceled'" fab style="width: 26px; height: 26px;" x-small class="py-1" color="gray" dark><v-icon style="font-size: 18px;">mdi-file-replace</v-icon></v-btn>
                                    <v-btn v-if="item.status === 'sent'" fab style="width: 26px; height: 26px;" x-small class="py-1" color="green" dark><v-icon style="font-size: 24px;">mdi-cube-send</v-icon></v-btn>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>

import {getAllOwnerOrders} from "../../api/orders";
import {getAdminWebsites} from "@/api/websites";

export default{
    computed:{
        filterStatuses(){
            return this.$store.getters.statuses
        }
    },
    data(){
        return {
            filter_params: {},
            media: null,
            orders: null,
            headers:[
                {
                    text: 'ID',
                    value: 'id',
                    sortable: true,
                    width: '70px',
                    align: 'center'
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: true,
                    width:'90px',
                    align: 'center'
                },
                {
                    text: 'Website',
                    value: 'buyer',
                    sortable: false,
                    width: '150px',
                    align: 'left'
                },
                {
                    text: 'Email',
                    value: 'email',
                    sortable: true,
                    width:'120px',
                    align: 'left'
                },
                {
                    text: 'Order total',
                    value: 'amount',
                    sortable: true,
                    expandable:true,
                    width: '120px',
                    align: 'left'
                },
                {
                    text: 'Store margin',
                    value: 'amount_for_website',
                    sortable: true,
                    expandable:true,
                    width: '120px',
                    align: 'left'
                }
            ],

            expanded: [],
            params: {},
            load: false,
            websites: null,
            statuses: null,
            users: null,
            usersSortedByEmail: null,
        }
    },
    mounted(){
        this.getOrders();
        this.getWebsites();
    },
    methods:{
        getOrders(){
            this.load = true;
            var params = {paid: 1, user_id: this.$store.getters.user.id,...this.filter_params};
            getAllOwnerOrders(params).then(res=>{
                this.orders = res;
                this.load = false;
            })
        },
        getWebsites(){
            getAdminWebsites().then(res=>{
                res = res.filter(website=>{
                    if(website.user_id == this.$store.getters.user.id) return true;
                });
                this.websites = res;

                this.websites.sort(function(a, b){
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                })
            })
        }

    },
    watch:{
        filter_params:{
            deep: true,
            handler: function () {
                window.clearTimeout(this.params_timeout);
                this.params_timeout = setTimeout(() => {
                    this.getOrders();
                }, 700)
            }
        },
    },
}
</script>
